import { createSlice } from "@reduxjs/toolkit";
import { fetchMapTeacherStatsData } from "../thunks/dashboardThunk"; 

const dashboarTeacherMapStateInt = createSlice({
  name: "MapTeacherStatsInt",
  initialState: {
    data: {
      data:[],
      statusCode:0,
      message:"",
      success:false
    },
    
    isLoading:false,
    isError:false
  },

 
  reducers: {},
  extraReducers: (builder) => {
    
    builder
      .addCase(fetchMapTeacherStatsData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchMapTeacherStatsData.fulfilled, (state, action) => {
        state.data = action.payload.data===""?[]:action.payload;
        state.isLoading = false;
      })
      .addCase(fetchMapTeacherStatsData.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
      })
      
  },
});

export default dashboarTeacherMapStateInt.reducer;